import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import {regexPatterns} from './../../../utilities/validation/validationVariables';
import {validateFields, validateField, validateValue} from './../../../utilities/validation/validator';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';
import {getRecaptchaToken} from './../../../utilities/recaptcha/recaptcha';
import lodash from 'lodash';

//------------------ createAsyncThunk ------------------
export const checkCellcomEnergy = createAsyncThunk('cellcomEnergyBlock/checkCellcomEnergy', async (address, thunkAPI) => {
  try {
    //thunkAPI.dispatch(showAppLoader());
    const token = await getRecaptchaToken('checkCellcomEnergy');
    if (token == undefined || token == null || token == '') {
      thunkAPI.dispatch(goToPage('errorPage'));
      return;
    }

    //let newAddress = Object.assign({}, address);
    const newAddress = {...address, token};

    const result = await ProviderManager.getProviderData('checkCellcomEnergy', newAddress);
    const hasCellcomEnergy = result.Body.hasCellcomEnergy;
    thunkAPI.dispatch(setHasCellcomEnergy(hasCellcomEnergy));
    thunkAPI.dispatch(goToPage('leadPage'));
  } catch (error) {
  } finally {
    //thunkAPI.dispatch(hideAppLoader());
  }
});

export const openWorkOrder = createAsyncThunk('cellcomEnergyBlock/openWorkOrder', async (leadData, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());

    const token = await getRecaptchaToken('openWorkOrder');
    if (token == undefined || token == null || token == '') {
      thunkAPI.dispatch(goToPage('errorPage'));
      return;
    }

    leadData.token = token;

    const request = buildWorkOrderRequest(leadData);
    console.info('openWorkOrder - request', request);
    const result = await ProviderManager.getProviderData('openWorkOrder', request);
    const isSuccess = result.Body.isSuccess;

    thunkAPI.dispatch(hideAppLoader());

    if (isSuccess) {
      thunkAPI.dispatch(goToPage('successPage'));
    } else {
      thunkAPI.dispatch(goToPage('errorPage'));
    }

    const res = {
      isSuccess: isSuccess,
      leadData: leadData,
    };
    return res;
  } catch (error) {
    console.error('openWorkOrder - error : ', error);
    thunkAPI.dispatch(hideAppLoader());
    thunkAPI.dispatch(goToPage('errorPage'));
  } finally {
    //thunkAPI.dispatch(hideAppLoader());
  }
});
//------------------ createAsyncThunk ------------------

const initialState = {
  page: '',
  isSubmit: false,
  isValid: false,
  hasCellcomEnergy: false,
  selectedAddress: {},
  fuTypeAddressSupported: '', //private:ATR1, business:ATR2
  fuTypeAddressNotSupported: '', //private:ATR1, business:ATR2
  form: {
    contractNumber: '',
    counterNumber: '',
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    isCallBackConfirm: false,
    rules: {},
    errors: {},
  },
};

const cellcomEnergyBlockSlice = createSlice({
  name: 'cellcomEnergyBlock',
  initialState: initialState,
  reducers: {
    resetBlock: (state) => initialState,
    initBlock: (state, action) => {
      state.page = 'addressPage';
      state.fuTypeAddressSupported = action.payload.iContent.fuTypeAddressSupported.value;
      state.fuTypeAddressNotSupported = action.payload.iContent.fuTypeAddressNotSupported.value;
    },
    goToPage: (state, action) => {
      state.page = action.payload;
      window.scrollTo(0, 0);
    },
    setSelectedAddress: (state, action) => {
      state.selectedAddress = action.payload;
    },
    changeHandler: (state, action) => {
      state.form[action.payload.field] = action.payload.value;

      let error = '';

      if (action.payload.field == 'isCallBackConfirm') {
        error = action.payload.value ? '' : state.form.rules['isCallBackConfirm'].required.error;
      } else {
        error = validateValue(state.form.rules[action.payload.field], action.payload.field, action.payload.value);
      }

      state.form.errors[action.payload.field] = error;

      if (error) {
        state.form.valid = false;
      } else {
        state.form.valid = '';
      }
    },
    validateHandler: (state, action) => {
      const form = lodash.cloneDeep(state.form);
      form.valid = '';
      const updatedForm = validateFields(form);

      if (updatedForm.isCallBackConfirm == false) {
        updatedForm.errors['isCallBackConfirm'] = updatedForm.rules['isCallBackConfirm'].required.error;
        updatedForm.valid = false;
      } else {
        updatedForm.errors['isCallBackConfirm'] = '';
      }

      state.form = updatedForm;
    },
    initValidation: (state, action) => {
      state.form.valid = '';
    },
    initRules: (state, action) => {
      const rules = {
        firstName: {
          required: {value: true, error: 'יש להזין שם פרטי'},
          pattern: {value: regexPatterns.lettersRegex, error: 'שם פרטי לא תקין'},
        },
        lastName: {
          required: {value: true, error: 'יש להזין שם משפחה'},
          pattern: {value: regexPatterns.lettersRegex, error: 'שם משפחה לא תקין'},
        },
        email: {
          required: {value: true, error: 'יש להזין דואר אלקטרוני'},
          pattern: {value: regexPatterns.emailRegex, error: 'דואר אלקטרוני לא תקין'},
        },
        phone: {
          required: {value: true, error: 'יש להזין מספר נייד'},
          pattern: {value: regexPatterns.phoneRegex, error: 'מספר נייד לא תקין'},
        },
        isCallBackConfirm: {
          required: {value: true, error: 'יש לאשר את התנאים'},
        },
      };

      if (state.hasCellcomEnergy) {
        rules.contractNumber = {
          required: {value: true, error: 'יש להזין מספר חוזה'},
          pattern: {value: regexPatterns.numbersRegex, error: 'מספר חוזה לא תקין'},
        };
        rules.counterNumber = {
          required: {value: true, error: 'יש הזין מספר מונה'},
          pattern: {value: regexPatterns.numbersRegex, error: 'מספר מונה לא תקין'},
        };
      }

      state.form.rules = rules;
    },
    setIsCallBackConfirm: (state, action) => {
      state.form.isCallBackConfirm = action.payload;
    },
    //validation
    setIsSubmit: (state, action) => {
      state.isSubmit = action.payload;
    },
    setIsValid: (state, action) => {
      state.isValid = action.payload;
    },
    setHasCellcomEnergy: (state, action) => {
      state.hasCellcomEnergy = action.payload;
    },
  },
});

const {setHasCellcomEnergy} = cellcomEnergyBlockSlice.actions;

export const {
  resetBlock,
  initBlock,
  goToPage,
  setSelectedAddress,
  changeHandler,
  validateHandler,
  initValidation,
  initRules,
  setIsCallBackConfirm,
  setIsSubmit,
  setIsValid,
} = cellcomEnergyBlockSlice.actions;

export default cellcomEnergyBlockSlice.reducer;

function buildWorkOrderRequest(leadData) {
  let request = {};
  try {
    request = {
      Token: leadData.token,
      ApplicationId: 'CELLCOM_WEB_SITE',
      FuSource: 'Z',
      FuType: leadData.fuType,
      FuText: `מכר ${window.Config.brand_Name_HE} Energy`,
      OperatorId: 'SCARE',
      FuBan: '',
      FuSubscriber: leadData.phone,
      ListRow: [
        {
          ParamCode: 'PFIRST_NAME',
          ParamValue: leadData.firstName,
        },
        {
          ParamCode: 'PLAST_NAME',
          ParamValue: leadData.lastName,
        },
        {
          ParamCode: 'PEMAIL',
          ParamValue: leadData.email,
        },
        {
          ParamCode: 'PTELEPHONE_NO',
          ParamValue: leadData.phone,
        },
        {
          ParamCode: 'Z151026',
          ParamValue: leadData.contractNumber ? leadData.contractNumber : '0',
        },
        {
          ParamCode: 'Z151027',
          ParamValue: leadData.counterNumber ? leadData.counterNumber : '0',
        },
        {
          ParamCode: 'Z9226',
          ParamValue: '0',
        },
      ],
    };
  } catch (error) {}

  return request;
}
